<template>
  <basic-dialog :show="show" max-width="1200px" @close="$emit('close')" draggable>
    <template v-slot:title>
      {{ service.name }} - Routes
    </template>
    <service-routes
      v-if="service.id"
      :service-id="service.id"
      :value="routes"
      @input="routes = $event"
    ></service-routes>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog";
import ServiceRoutes from "./ServiceRoutes";
import gql from "graphql-tag";

const GET_SERVICE_ROUTES = gql`
  query getServiceRoutes($id: ID!) {
    node(id: $id) {
      ... on Service {
        serviceRoutes {
          edges {
            node {
              id
              name
              code
              description
              coordinates
              tags
              color
              sequence
              date
              pois {
                edges {
                  node {
                    id
                    name
                    lng
                    lat
                    description
                    radius
                    audio
                    type {
                      id
                      name
                      iconName
                      iconSVG
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default {
  name: "service-routes-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    service: {
      type: Object,
      default: () => ({ id: null, name: "" }),
    },
  },

  components: { BasicDialog, ServiceRoutes },

  data() {
    return {
      routes: [],
    };
  },

  mounted() {
    if (this.show && this.service.id) {
      this.loadRoutes();
    }
  },

  watch: {
    show(val) {
      if (val && this.service.id) {
        this.loadRoutes();
      }
    },
  },

  methods: {
    loadRoutes() {
      this.$apollo
        .query({
          query: GET_SERVICE_ROUTES,
          variables: { id: this.service.id },
          fetchPolicy: "network-only",
        })
        .then((result) => {
          const edges = result.data.node.serviceRoutes.edges;
          this.routes = edges.map((e) => ({
            ...e.node,
            pois: e.node.pois.edges.map((pe) => pe.node),
          }));
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/suppliers/services/routes/ServiceRoutesDialog.vue